"use client";

import { useEffect } from "react";
import Footer from "@/components/footer";
import CNCServiceCard from "@/components/cnc-service-card";
import MaterialsTabs from "@/components/materials-tabs";
import ProcessTimeline from "@/components/process-timeline";
import LetsTalkForm from "@/components/lets-talk-form";

const cncServices = [
  "Turning",
  "Drilling",
  "Boring",
  "Reaming",
  "Honing",
  "Grinding",
  "Planing",
  "Threading",
  "Tapping",
  "Undercuts",
  "Deep Cavities",
];

export default function ProcessesClient() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section - Our Processes */}
      <section className="py-8 md:py-12">
        <div className="mx-auto max-w-[1200px] px-4 md:px-8">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
            {/* Left Text */}
            <div className="lg:w-[50%] flex flex-col justify-center space-y-4 md:space-y-6 text-center lg:text-left">
              <h1 className="text-2xl sm:text-3xl md:text-5xl text-[var(--mmi-heading)]">
                Quality Assurance
              </h1>

              <div className="flex justify-center lg:justify-start">
                <div className="w-24 md:w-32 h-1 bg-[var(--brand-yellow)]" />
              </div>
              <p className="text-sm sm:text-base md:text-lg text-[var(--mmi-body)] leading-relaxed">
                Quality assurance is managed through defined quality systems,
                ISO 9001 certification, IATF 16949:2016, and PPAP
                implementation, with quality controls, inspections, and
                verification applied across all production stages to confirm
                conformance to customer drawings, technical specifications, and
                delivery requirements, ensure consistent output and traceability
                across programs, and, where applicable, include simulation and
                flow analysis and penetrant testing for porosity and shrinkage
                detection.
              </p>
            </div>
            {/* Right Placeholder Card (bigger on mobile) */}
            <div className="w-full lg:w-[35%] mx-auto lg:mx-0">
              <div className="relative w-full aspect-[4/3] rounded-[24px] overflow-hidden shadow-sm">
                <img
                  src="/quality/baner.jpg"
                  alt="Casting process"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-12 space-y-20">
          {/* ===== Block 1: Text LEFT | Image RIGHT ===== */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-center">
            {/* Text */}
            <div className="order-1">
              <h3 className="text-xl md:text-3xl text-[var(--mmi-heading)] mb-4">
                Quality Capabilities
              </h3>

              <ul className="space-y-3 text-sm md:text-lg text-[var(--mmi-body)] list-disc pl-5">
                <li>CMM inspection</li>
                <li>PPAP documentation and submission</li>
                <li>Precision gauging</li>
                <li>Corrective and preventive action protocols</li>
                <li>Inspection and quality reports provided on request</li>
              </ul>
            </div>

            {/* Image */}
            <div className="order-2 flex justify-center md:justify-end">
              <img
                src="/quality/1.jpg"
                alt="Quality Capabilities"
                className="w-full max-w-[520px] aspect-[4/3] object-cover rounded-3xl"
              />
            </div>
          </div>

          {/* ===== Block 2: Image LEFT | Text RIGHT ===== */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-center">
            {/* Image */}
            <div className="order-2 flex justify-center md:justify-end">
              <img
                src="/quality/2.jpg"
                alt="Quality Capabilities"
                className="w-full max-w-[520px] aspect-[4/3] object-cover rounded-3xl"
              />
            </div>

            {/* Text */}
            <div className="order-1 md:order-2">
              <h3 className="text-xl md:text-3xl text-[var(--mmi-heading)] mb-4">
                QC Infrastructure
              </h3>

              <ul className="space-y-3 text-sm md:text-lg text-[var(--mmi-body)] list-disc pl-5">
                <li>Dedicated quality inspection laboratory</li>
                <li>Advanced measuring and inspection instruments</li>
                <li>Trained and experienced quality personnel</li>
              </ul>
            </div>
          </div>

          {/* ===== Block 3: Text LEFT | Image RIGHT ===== */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-center">
            {/* Text */}
            <div className="order-1">
              <h3 className="text-xl md:text-3xl text-[var(--mmi-heading)] mb-4">
                Quality & Traceability
              </h3>

              <ul className="space-y-3 text-sm md:text-lg text-[var(--mmi-body)] list-disc pl-5">
                <li>Incoming, in-process, and final inspection checks</li>
                <li>Serialized tracking and labeling where specified</li>
                <li>
                  Testing conducted as per customer or application requirements
                </li>
                <li>
                  Inspection reports and material test reports always available
                </li>
              </ul>
            </div>

            {/* Image */}
            <div className="order-2 flex justify-center md:justify-end">
              <img
                src="/quality/3.jpg"
                alt="Quality Capabilities"
                className="w-full max-w-[520px] aspect-[4/3] object-cover rounded-3xl"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
